import { forwardRef } from 'react';

import { Container, ContainerProps } from './styles';

export type BoxProps = React.HTMLAttributes<HTMLElement> & ContainerProps;

const Box = forwardRef(({ className, ...rest }: BoxProps, ref) => (
  <Container ref={ref} className={className} {...rest} />
));

export default Box;
